import * as tsx from 'vue-tsx-support';
import { SiteSettingsStore } from '@/store';
import { emptyVNode } from '@/utils';
import * as lazyLoader from './LazyLoader';
/**
 * Create a lazy loaded component that only is loaded when a feature flag is enabled.
 *
 * DO NOT USE IN A COMPUTED PROPERTY, the component might not load until the
 * second time the lazy loader is rendered.
 *
 * @param args The arguments used to construct the lazy loader and feature checker with.
 * @returns The given component wrapped as a lazy loader that is only loaded when a feature flag is
 * enabled.
 */
export function featureFlagged(args) {
    const Inner = lazyLoader.lazyLoadView(args);
    const res = tsx.component({
        name: 'feature-flagged',
        inheritAttrs: false,
        /**
         * Render the component.
         *
         * @param h The way to create a elements.
         * @returns The rendered component.
         */
        render(h) {
            const vnodedata = {
                attrs: this.$attrs,
                props: this.$props,
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
            };
            const maybeTenantId = args.getTenantId(this.$attrs);
            const isEnabled = maybeTenantId.caseOf({
                Nothing: () => SiteSettingsStore.getGlobalSetting()(args.featureFlag),
                Just: tid => SiteSettingsStore.getSetting()(args.featureFlag, tid),
            });
            if (!isEnabled) {
                if (args.fallbackComponent != null) {
                    return h(args.fallbackComponent, vnodedata);
                }
                return emptyVNode();
            }
            return h(Inner, vnodedata);
        },
    });
    return res;
}
/**
 * Create a lazy loaded component that only is loaded when a tier add-on is enabled.
 *
 * DO NOT USE IN A COMPUTED PROPERTY, the component might not load until the
 * second time the lazy loader is rendered.
 *
 * @param args The arguments used to construct the lazy loader and feature checker with.
 * @returns The given component wrapped as a lazy loader that is only loaded when a feature flag is
 * enabled.
 */
export function tierRestricted(args) {
    const Inner = lazyLoader.lazyLoadView(args);
    const res = tsx.component({
        name: 'tier-restricted',
        inheritAttrs: false,
        /**
         * Render the component.
         *
         * @param h The way to create a elements.
         * @returns The rendered component.
         */
        render(h) {
            const course = args.getCourse(this.$attrs);
            if (!SiteSettingsStore.getAddon()(course, args.tierAddon)) {
                return emptyVNode();
            }
            return h(Inner, {
                attrs: this.$attrs,
                props: this.$props,
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
            });
        },
    });
    return res;
}
